'use strict'

// TODO use WebCrypto uuid() if it is available
const { v4: uuidv4 } = require('uuid')
module.exports = uuidv4
